// extracted by mini-css-extract-plugin
export default {"errorPage":"errorPage__KMu3NHVI"};